export default "__VITE_ASSET__Cjs5X1_4__"